import { reportWorkTypes } from "constants/layout";
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    Card,
    CardBody,
    Col,
    Row,
    Button
} from "reactstrap";
import { getBranches, getOptions } from "./optionsServices";
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
import Timezone from "utils/timezone";
import { MultiSelect } from "react-multi-select-component";

const initObj = {
    type: 'all',
    branch: 'all',
    dates: [new Date()],
    client: [],
    city: [],
    category: '',
    producttype: '',
    product: ''
}

export const Filters = ({callback, filterOptions={}}) => {
    const [branches, setBranches] = useState(null);
    const [clients, setClients] = useState(null);
    const [cities, setCities] = useState(null);
    const [selectedDates, setSelectedDates] = useState([new Date()]);

    const [categories, setCategories] = useState(null);
    const [productTypes , setProductTypes] = useState(null);
    const [products , setProducts] = useState(null);
    const [filterData, setFilterData] = useState(initObj);
    const [dropdownSelection, setDropdownSelection] = useState({
        city: [],
        client:[],
        p_catygory:[],
        p_type:[],
        product:[]
    });

    useEffect(() => {
        let mounted = true;

        const loadBranches = async () => {
            const result = await getBranches();
            if (mounted) {
                setBranches(result);
            }
        };

        loadBranches();
        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        let mounted = true;

        const loadOptions = async () => {
            const calls = [];
            const keys = [];

            if (filterOptions.city) {
                calls.push(getOptions(filterData.branch, 'cities'));
                keys.push('cities');
            }

            if (filterOptions.client) {
                calls.push(getOptions(filterData.branch, 'clients'));
                keys.push('clients');
            }

            if (filterOptions.category) {
                calls.push(getOptions(filterData.branch, 'categories'));
                keys.push('categories');
            }

            if (filterOptions.p_type) {
                calls.push(getOptions(filterData.branch, 'productTypes'));
                keys.push('productTypes');
            }

            if (filterOptions.product) {
                calls.push(getOptions(filterData.branch, 'products'));
                keys.push('products');
            }

            const results = await Promise.all(calls);

            if (mounted) {
                results.forEach((res, idx) => {
                    switch (keys[idx]) {
                        case 'cities': setCities(res); break;
                        case 'clients': setClients(res); break;
                        case 'categories': setCategories(res); break;
                        case 'productTypes': setProductTypes(res); break;
                        case 'products': setProducts(res); break;
                    }
                });

                // Trigger parent callback only once after all options load
                handleSubmit();
            }
        };

        loadOptions();

        return () => {
            mounted = false;
        };
    }, [filterData.branch]);

    const handleSubmit = () => {
        const activeFilters = {};

        // Loop through filterOptions and pick only enabled ones
        for (const key in filterOptions) {
            if (filterOptions[key] && filterData[key] !== undefined) {
            activeFilters[key] = filterData[key];
            }
        }

        callback(activeFilters);
    };


    return(
        <Row>
            <Col>
                <Card className="cardfilters">
                    <CardBody className="p-0 border-0 shadow-none">
                        <Row>
                            {
                                filterOptions?.order_type && 
                                <Col className={'mb-3'}>
                                    <label>Order Type</label>
                                    <select className="form-control" onChange={(e) => {setFilterData(prev => ({...prev, type: e.target.value}))}}>
                                    {
                                        reportWorkTypes?.map((v, i) => <option key={`WT_${i}`} value={v.id}>{v.title}</option>)
                                    }
                                    </select>
                                </Col>
                            }

                            {
                                filterOptions?.city && 
                                <Col className={'mb-3'}>
                                    <label>Select City</label>
                                    <MultiSelect
                                        options={cities || []}
                                        value={dropdownSelection?.city}
                                        onChange={(e) => {
                                            if(e.length > 0){
                                                setFilterData(prev => ({...prev, city: [...prev.city, e[0].value]}))
                                                setDropdownSelection(prev => ({...prev, city: e}))
                                            }else{
                                                setFilterData(prev => ({...prev, city: e}))
                                                setDropdownSelection(prev => ({...prev, city: e}))
                                            }
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.client && 
                                <Col className={'mb-3'}>
                                    <label>Select Client</label>
                                    <MultiSelect
                                        options={clients || []}
                                        value={dropdownSelection?.client}
                                        onChange={(e) => {
                                            if(e.length > 0){
                                                setFilterData(prev => ({...prev, client: [...prev.client, e[0].value]}))
                                                setDropdownSelection(prev => ({...prev, client: e}))
                                            }else{
                                                setFilterData(prev => ({...prev, client: e}))
                                                setDropdownSelection(prev => ({...prev, client: e}))
                                            }
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }
                            
                            {
                                filterOptions?.dates && 
                                <Col className={'mb-4'}>
                                    <label>Date Range</label>
                                    <Flatpickr
                                        className="form-control d-block"
                                        placeholder="DD-MM-YYYY"
                                        options={{
                                            mode: "range",
                                            dateFormat: "d-m-Y"
                                        }}
                                        value={selectedDates}
                                        onChange={
                                            (e) => {
                                                const dates = e.map(dateString => Timezone(dateString));
                                                setFilterData(prev => ({...prev, dates: dates}))
                                                setSelectedDates(e)
                                            }
                                        }
                                    />
                                </Col>
                            }

                            {
                                filterOptions?.category && 
                                <Col className={'mb-3'}>
                                    <label>Product Category</label>
                                    <MultiSelect
                                        options={categories || []}
                                        value={dropdownSelection?.p_catygory}
                                        onChange={(e) => {
                                            if(e.length > 0){
                                                setFilterData(prev => ({...prev, category: [...prev.category, e[0].value]}))
                                                setDropdownSelection(prev => ({...prev, p_catygory: e}))
                                            }else{
                                                setFilterData(prev => ({...prev, category: e}))
                                                setDropdownSelection(prev => ({...prev, p_catygory: e}))
                                            }
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }
                            
                            {
                                filterOptions?.p_type && 
                                <Col className={'mb-3'}>
                                    <label>Product type</label>
                                    <MultiSelect
                                        options={productTypes || []}
                                        value={dropdownSelection?.p_type}
                                        onChange={(e) => {
                                            if(e.length > 0){
                                                setFilterData(prev => ({...prev, producttype: [...prev.producttype, e[0].value]}))
                                                setDropdownSelection(prev => ({...prev, p_type: e}))
                                            }else{
                                                setFilterData(prev => ({...prev, producttype: e}))
                                                setDropdownSelection(prev => ({...prev, p_type: e}))
                                            }
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }
                            
                            {
                                filterOptions?.product && 
                                <Col className={'mb-3'}>
                                    <label>Product</label>
                                    <MultiSelect
                                        options={products || []}
                                        value={dropdownSelection?.product}
                                        onChange={(e) => {
                                            if(e.length > 0){
                                                setFilterData(prev => ({...prev, product: [...prev.product, e[0].value]}))
                                                setDropdownSelection(prev => ({...prev, product: e}))
                                            }else{
                                                setFilterData(prev => ({...prev, product: e}))
                                                setDropdownSelection(prev => ({...prev, product: e}))
                                            }
                                        }}
                                        labelledBy="Select"
                                    />
                                </Col>
                            }

                            <Col md={1} style={{marginTop: '24px', width: '142px'}}>
                                <Button style={{ backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }} className="float-end" onClick={handleSubmit} > Submit </Button>
                                <Button color="light" className="float-end mdi mdi-refresh me-1 border" title="reset filters" onClick={() => {
                                    setFilterData(initObj)
                                    setSelectedDates([new Date()])          
                                }} ></Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}